var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card podium-card h-100 shadow-sm" }, [
    _c("div", { staticClass: "card-body d-flex flex-column" }, [
      _c(
        "div",
        { staticClass: "podium-title text-uppercase font-weight-bold" },
        [
          _c("i", { staticClass: "fas fa-trophy mr-1" }),
          _vm._v(_vm._s(_vm.title) + "\n    "),
        ]
      ),
      _vm._v(" "),
      _vm.subTitle
        ? _c("div", { staticClass: "podium-subtitle text-muted small mb-2" }, [
            _vm._v(_vm._s(_vm.subTitle)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.loading
        ? _c(
            "div",
            {
              staticClass:
                "d-flex justify-content-center align-items-center flex-grow-1 py-3",
            },
            [_vm._m(0)]
          )
        : !_vm.items || _vm.items.length === 0
        ? _c(
            "div",
            {
              staticClass:
                "text-muted small text-center py-3 flex-grow-1 d-flex align-items-center justify-content-center",
            },
            [_vm._v("\n      Sin datos en el rango seleccionado.\n    ")]
          )
        : _c(
            "ul",
            { staticClass: "podium-list flex-grow-1" },
            _vm._l(_vm.rows, function (row) {
              return _c(
                "li",
                {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip.hover.left",
                      value: _vm.tooltipText(row),
                      expression: "tooltipText(row)",
                      modifiers: { hover: true, left: true },
                    },
                  ],
                  key: row.rank,
                  staticClass: "podium-row",
                  class: ["rank-" + row.rank, { "is-empty": !row.item }],
                },
                [
                  _c("span", { staticClass: "podium-medal" }, [
                    _vm._v(_vm._s(row.rank)),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "podium-label" }, [
                    _vm._v(_vm._s(row.item ? row.item.label : "—")),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "podium-count" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(row.item ? row.item.count : 0) +
                        "\n          "
                    ),
                    row.percent != null
                      ? _c("small", { staticClass: "podium-percent" }, [
                          _vm._v(_vm._s(_vm.formatPercent(row.percent))),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "podium-bar-track" }, [
                    _c("span", {
                      staticClass: "podium-bar-fill",
                      style: { width: row.barWidth + "%" },
                    }),
                  ]),
                ]
              )
            }),
            0
          ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "spinner-border spinner-border-sm text-muted",
        attrs: { role: "status" },
      },
      [_c("span", { staticClass: "sr-only" }, [_vm._v("Cargando...")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }